module.exports = {"taskPanel":{"assignTo":"InvalidToEmail"},"gipsybotmelink":{"invalidCharacters":"Invalid. Please use lowercase only 'a-z', '0-9', or '-' characters","linkIDUnavailable":"This link ID is unavalaible"}}


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/errors/errors.json
// module id = 629
// module chunks = 0